import { FormattedMessage, useIntl } from 'react-intl'

import type { ColumnDef } from '@gto/ui/data-table'
import { createColumns } from '@gto/ui/data-table'

import { fixedColumn, fluidColumn } from '@/components/table-columns'
import type { Translations } from '@/localise'
import { safeNumber } from '@/utils/helpers'

export type FlipOutRow = {
  id: string
  prize: keyof Translations
  prizesCount: number
  prizeValue: number
  totalValue: number
}

export const useFlipOutPrizesTableCols = (): ColumnDef<FlipOutRow>[] => {
  const { formatMessage, formatNumber } = useIntl()

  /** Whole-dollar prize money, or a dash for a prize with no cash value. */
  const money = (value: number) => {
    const sum = safeNumber(value)

    return sum
      ? formatNumber(sum, { style: 'currency', currency: 'USD', minimumFractionDigits: 0 })
      : '-'
  }

  return createColumns<FlipOutRow>([
    {
      accessorKey: 'prize',
      header: formatMessage({ id: 'promo.rakeRace.table.prize' }),
      ...fluidColumn({ min: 180 }),
      // The row's `prize` IS a message id, not a label.
      cell: ({ row }) => <FormattedMessage id={row.original.prize} />,
    },
    {
      accessorKey: 'prizesCount',
      header: formatMessage({ id: 'promo.rakeRace.table.prizesCount' }),
      ...fixedColumn({ min: 120 }),
    },
    {
      accessorKey: 'prizeValue',
      header: formatMessage({ id: 'promo.rakeRace.table.valueEach' }),
      ...fixedColumn({ min: 120 }),
      cell: ({ row }) => money(row.original.prizeValue),
    },
    {
      accessorKey: 'totalValue',
      header: formatMessage({ id: 'promo.rakeRace.table.totalValue' }),
      ...fixedColumn({ min: 120 }),
      cell: ({ row }) => money(row.original.totalValue),
    },
  ])
}
